/**
 * 滚动元素外部事件
 * @param {HTMLElement} el - 绑定指令的元素
 * @param {Function} binding.value - 绑定指令的值
 * @example
 * <div v-scroll-outside="handleScrollOutside"></div>
 */

const scrollOutside = {
  mounted(el, binding) {
    const { arg } = binding;
    function eventHandler(e) {
      if (arg) {
        el = document.querySelector(`.${arg}`);
      }
      // 检查滚动是否发生在元素外部
      if (el.contains(e.target)) {
        return false;
      }
      // 如果绑定的参数是函数，执行
      if (binding.value && typeof binding.value === 'function') {
        binding.value(e);
      }
    }
    // 用于销毁前注销事件监听
    el.__scroll_outside__ = eventHandler;
    // 添加滚动事件监听
    document.addEventListener('scroll', eventHandler, true);
  },
  beforeUnmount(el) {
    // 移除事件监听
    document.removeEventListener('scroll', el.__scroll_outside__, true);
    // 删除无用属性
    delete el.__scroll_outside__;
  }
};

export default scrollOutside;
